// components/KnowlarityWidget2.js
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const KnowlarityWidget2 = () => {
  const visible = useSelector((state) => state.tokenReducer.visible);
  const [loaded, setLoaded] = useState(false);

  // Load Knowlarity script once
  useEffect(() => {
    const setConfig = () => {
      if (window.KNW_WIDGET?.setUserConfig) {
        window.KNW_WIDGET.setUserConfig({
          height: "550px",
          width: "400px",
          src: "https://konnect.knowlarity.com/external/#",
        });
        setLoaded(true);
        console.log("Knowlarity widget configured ✅");
      }
    };

    if (!document.getElementById("knw-widget-sdk")) {
      const script = document.createElement("script");
      script.id = "knw-widget-sdk";
      script.src = "https://konnect.knowlarity.com/external/embed/widget.js";
      script.onload = setConfig;
      document.body.appendChild(script);
      console.log("Knowlarity widget script loaded 🚀");
    } else {
      setConfig();
    }
  }, []);

  // Show/hide widget when Redux `visible` changes
  useEffect(() => {
    // if (!loaded) return;

    // const iframe = document.querySelector(
    //   "iframe[src*='konnect.knowlarity.com']"
    // );
    // const launcher = document.querySelector("div[id*='KNW_WIDGET']"); // floating button

    // if (iframe) iframe.style.display = visible ? "block" : "none";
    // if (launcher) launcher.style.display = visible ? "block" : "none";
    if (!visible){
        hideKnowlarityWidget();
    }else{
        showKnowlarityWidget();
    }
  }, [visible, loaded]);

  return null;
};


const hideKnowlarityWidget = () => {
  try {
    const widget = document.querySelector("div#knw_widget_main");
    if (widget) {
      widget.style.display = "none";
      console.log("VoiceXcel widget hidden ✅");
    } else {
      console.log("VoiceXcel widget not found ❌");
    }
  } catch (err) {
    console.error("Error hiding Knowlarity widget:", err);
  }
};

const showKnowlarityWidget = () => {
  try {
    const widget = document.querySelector("div#knw_widget_main");
    if (widget) {
      widget.style.display = "block";
      console.log("VoiceXcel widget hidden ✅");
    } else {
      console.log("VoiceXcel widget not found ❌");
    }
  } catch (err) {
    console.error("Error hiding Knowlarity widget:", err);
  }
};

export default KnowlarityWidget2;
